
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Code, Note, Preview } from "@lighting-beetle/lighter-styleguide";
import { Grid, GridCol } from "./../components";
import "./../styles/base/styleguide.scss";
export const breakpoints = ["xs", "s", "m", "l", "xl"];
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  breakpoints
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1>{`Visibility utilities`}</h1>
    <Preview hasCodePreview={false} mdxType="Preview">
  <ul>
    <li>
      <Code mdxType="Code">.hide</Code> hides the element with{" "}
      <Code mdxType="Code">display: none !important</Code>
    </li>
    <li>
      <Code mdxType="Code">.inivisble</Code> hides the element with{" "}
      <Code mdxType="Code">visibility: hidden</Code>
    </li>
    <li>
      <Code mdxType="Code">.visually-hidden, .sr-only</Code> hides the element from view, but
      remains accessible by screen readers
    </li>
  </ul>
    </Preview>
    <h2>{`Responsive visibility utility classes`}</h2>
    <p>{`Programatically show or hide elements for specific breakpoints.`}</p>
    <ul>
      <li parentName="ul">{`\``}{`.show/hide-`}{`[breakpoint]`}{`-only`}{`\``}{` shows/hides the element only for the specified breakpoint`}</li>
      <li parentName="ul">{`\``}{`.show/hide-`}{`[breakpoint]`}{`\``}{`. shows/hides the element for the specified breakpoint AND larger`}</li>
    </ul>
    <Note title="className's availability" mdxType="Note">
  * <Code mdxType="Code">.hide-xs, .show-xs</Code> are not available, as XS is the default
  breakpoint. To hide an element completely, use <Code mdxType="Code">.hide</Code>*{" "}
  <Code mdxType="Code">.show-xl-only, .hide-xl-only</Code> are not available, as XL is the
  largest breakpoint. The same can be accomplished using{" "}
  <Code mdxType="Code">.show-xl, .hide-xl</Code>
    </Note>
    <Preview hasCodePreview={false} mdxType="Preview">
  <div className="l-debug mb">
    Active breakpoint: <strong className="show-xs-only">XS</strong>
    <strong className="show-s-only">S</strong>
    <strong className="show-m-only">M</strong>
    <strong className="show-l-only">L</strong>
    <strong className="show-xl-only">XL</strong>
  </div>
  {breakpoints.map((breakpoint, index) => <Grid key={breakpoint} className="mb" mdxType="Grid">
      <GridCol size={2} mdxType="GridCol">
        <strong className="h5 text-right">{breakpoint.toUpperCase()}</strong>
      </GridCol>
      <GridCol size={10} mdxType="GridCol">
        {index > 0 && <div className={`show-${breakpoint}`}>
            <Code mdxType="Code">{`.show-${breakpoint}`}</Code> Your screen is{" "}
            <strong>{breakpoint.toUpperCase()}</strong> or larger
          </div>}
        {index + 1 < breakpoints.length && <div className={`show-${breakpoint}-only`}>
            <Code mdxType="Code">{`.show-${breakpoint}-only`}</Code> Your screen is larger than{" "}
            <strong>{breakpoint.toUpperCase()}</strong> and smaller than{" "}
            <strong>{breakpoints[index + 1].toUpperCase()}</strong>
          </div>}
        {index > 0 && <div className={`hide-${breakpoint}`}>
            <Code mdxType="Code">{`.hide-${breakpoint}`}</Code> Your screen is smaller than{" "}
            <strong>{breakpoint.toUpperCase()}</strong>
          </div>}
        {index + 1 < breakpoints.length && <div className={`hide-${breakpoint}-only`}>
            <Code mdxType="Code">{`.hide-${breakpoint}-only`}</Code> Your screen is{" "}
            {index > 0 && <span>
                either smaller than <strong>{breakpoint.toUpperCase()}</strong>{" "}
                or{" "}
              </span>}
            larger than <strong>{breakpoints[index + 1].toUpperCase()}</strong>
          </div>}
      </GridCol>
    </Grid>)}
    </Preview>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;